import { jsx as _jsx } from "react/jsx-runtime";
import { useCreatePlaylistModalPath } from '..';
import { RouterLink } from '../../../components/AcademyLinks';
import { FormattedMessage } from '../../../components/I18n';

const CreatePlaylistLink = ({
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.createPlaylist"
  }),
  render = (content, to) => /*#__PURE__*/_jsx(RouterLink, {
    to: to,
    children: content
  }),
  trackId,
  lessonId,
  language
}) => {
  const createPlaylistPath = useCreatePlaylistModalPath({
    trackId,
    lessonId,
    language
  });
  return render(children, createPlaylistPath);
};

export default CreatePlaylistLink;